// services/orders.js
import axiosInstance from './axiosInstance';

const ORDERS_API_URL = '/orders';

const ordersService = {
  async get(idempresa, filters = {}) {
    try {
      const { 
        start_date, 
        end_date, 
        doctype, 
        idprovider, 
        search, 
        page = 1, 
        pageSize = 10 
      } = filters;
      let url = `${ORDERS_API_URL}/get.php?idempresa=${idempresa}`;
      
      if (start_date && end_date) {
        url += `&start_date=${start_date}&end_date=${end_date}`;
      }
      
      if (doctype) {
        url += `&doctype=${doctype}`;
      }
      
      if (idprovider) {
        url += `&idprovider=${idprovider}`;
      }
      
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      
      if (page) {
        url += `&page=${page}`;
      }
      
      if (pageSize) {
        url += `&pageSize=${pageSize}`;
      }
      
      const response = await axiosInstance.get(url);
      
      // Se a resposta é inválida
      if (response.data === "NOK" || !response.data) {
        return {
          entries: [],
          totalPages: 0,
          totalItems: 0
        };
      }
      
      // A API já retorna a estrutura paginada com entries, totalPages, totalItems
      if (response.data && typeof response.data === 'object' && Array.isArray(response.data.entries)) {
        return {
          entries: response.data.entries || [],
          totalPages: response.data.totalPages || 0,
          totalItems: response.data.totalItems || 0
        };
      }
      
      // Fallback: tratar como estrutura vazia
      return {
        entries: [],
        totalPages: 0,
        totalItems: 0
      };
    } catch (error) {
      console.error(error);
      return {
        entries: [],
        totalPages: 0,
        totalItems: 0
      };
    }
  },

  async getById(idempresa, idorder) {
    try {
      const response = await axiosInstance.get(`${ORDERS_API_URL}/getById.php?idempresa=${idempresa}&idorder=${idorder}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async unset(idempresa, idorder) {
    try {
      const response = await axiosInstance.get(`${ORDERS_API_URL}/unset.php?idempresa=${idempresa}&idorder=${idorder}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async email(emailData) {
    try {
      const response = await axiosInstance.post(`${ORDERS_API_URL}/email.php`, emailData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getInvoicesById(idempresa, params) {
    try {
      const { talao, posto, serie, tpv } = params;
      const response = await axiosInstance.get(`${ORDERS_API_URL}/invoices/getById.php?idempresa=${idempresa}&talao=${talao}&posto=${posto}&serie=${serie}&tpv=${tpv}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async set(orderData) {
    try {
      const response = await axiosInstance.post(`${ORDERS_API_URL}/set.php`, orderData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar ordem:', error);
      throw error;
    }
  },

  async getOrdersForProvider(idempresa, idprovider) {
    try {
      const response = await axiosInstance.get(`${ORDERS_API_URL}/provider/get.php?idempresa=${idempresa}&idprovider=${idprovider}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter encomendas do fornecedor:', error);
      return [];
    }
  },

  async downloadCsv(idempresa, type, idorder) {
    try {
      const response = await axiosInstance.get(`${ORDERS_API_URL}/csv.php?idempresa=${idempresa}&type=${type}&idorder=${idorder}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Erro ao fazer download do CSV:', error);
      throw error;
    }
  },

  // Orders Payments (Liquidações)
  async setPayment(paymentData) {
    try {
      const response = await axiosInstance.post(`${ORDERS_API_URL}/payments/set.php`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar recibo de liquidação:', error);
      throw error;
    }
  },

  async getPendingOrders(idempresa, filters = {}) {
    try {
      const { start_date, end_date, idprovider, status = 'all' } = filters;
      let url = `${ORDERS_API_URL}/payments/getPendingOrders.php?idempresa=${idempresa}&status=${status}`;
      
      if (start_date) url += `&start_date=${start_date}`;
      if (end_date) url += `&end_date=${end_date}`;
      if (idprovider) url += `&idprovider=${idprovider}`;
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter orders pendentes:', error);
      return [];
    }
  },

  async getPayments(idempresa, filters = {}) {
    try {
      const { start_date, end_date } = filters;
      let url = `${ORDERS_API_URL}/payments/get.php?idempresa=${idempresa}`;
      
      if (start_date) url += `&start_date=${start_date}`;
      if (end_date) url += `&end_date=${end_date}`;
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter recibos:', error);
      return [];
    }
  },

  async getPaymentByNumero(idempresa, numero) {
    try {
      const response = await axiosInstance.get(`${ORDERS_API_URL}/payments/getByNumero.php?idempresa=${idempresa}&numero=${numero}`);
      return response.data !== "NOK" ? response.data : null;
    } catch (error) {
      console.error('Erro ao obter recibo:', error);
      return null;
    }
  }
};

export default ordersService;
